import clsx from 'clsx';
import Link from 'next/link';

import cn from '@/lib/clsxm';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import { CardAction } from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Actions from '@/components/shared/components/cards/@shared/actions';
import Props from '@/components/shared/components/cards/readySite/content/hover-mode/type';
import IconLinkCombo from '@/components/shared/components/icon-link-combo';
import PriceView from '@/components/shared/components/price-view';

import { DATA_CY_DEMO_NAME } from '@/constant/cypress';

export default function HoverMode({
  isHovered,
  productTitle,
  title,
  price,
  lastPrice,
  discount,
  saleEndedAt,
  icon,
  slug,
  id,
  demoId,
  sellable,
  store,
}: Props) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);

  const discountIsValid = saleEndedAt > currentTimeInSeconds && discount > 0;
  return (
    <Container
      className={cn(
        'absolute bottom-0 z-50 h-[145px] w-full bg-white px-4 pt-3 pb-3 transition duration-300 md:bottom-[-145px]',
        isHovered && 'z-50 md:bottom-0',
      )}
    >
      <Link href={`/web/${slug}`} passHref prefetch={false}>
        <Text size={SIZE_ENUM.MD} className='line-clamp-1 w-full! text-[#424244]'>
          {title}
        </Text>
      </Link>
      <Container center className='-mt-0.5 w-full justify-between'>
        <Container data-cy={DATA_CY_DEMO_NAME}>
          <IconLinkCombo
            Icon={
              <XImage
                src={store.logo.publicLink}
                width={22}
                height={22}
                alt={icon?.title}
                className='rounded-md!'
              />
            }
            textSize={SIZE_ENUM.XS}
            textClassName='text-[#76767C] w-full max-w-[150px] line-clamp-1'
            title={store.name}
            link={`/web/${slug}`}
            target='_blank'
          />
        </Container>

        <PriceView
          showDiscountLabel
          sellable={sellable}
          price={price}
          lastPrice={lastPrice}
          discount={discount}
          saleEndedAt={saleEndedAt}
          className='flex items-center gap-2'
          priceClassName='text-[#5B5C60] font-bold text-md'
          currencyClassName='text-[11px] text-[#76767C]'
        />
      </Container>
      <CardAction
        center
        className={clsx(
          'w-full gap-2 p-0',
          discountIsValid ? 'mt-0.5 md:mt-0.5' : 'mt-3.5 md:mt-3',
        )}
      >
        <Actions slug={slug} productId={id} demoId={demoId} />
      </CardAction>
    </Container>
  );
}
